<div class="container-fluid px-0">
  <div class="row">
    <div class="col-12">
      <div *ngIf="errorMessage" class="alert alert-danger small" role="alert">
        {{ errorMessage }}
      </div>

      <div
        class="resource-surface rounded-4 bg-white p-3 p-md-4 p-xl-5 border"
        #wizardTop
      >
        <div
          class="mb-4 border-bottom pb-3"
          [class.wizard-header--full]="isFinalStep"
        >
          <div
            class="mx-auto my-0 w-100 d-flex flex-wrap align-items-center justify-content-between gap-3"
          >
            <p class="text-muted small mb-0">
              {{ progressLabel }}
            </p>

            <div class="d-flex flex-wrap gap-2 align-items-center">
              <button
                *ngIf="!isFinalStep"
                type="button"
                class="btn btn-outline-secondary btn-sm"
                (click)="manualSave()"
              >
                Save draft
              </button>

              <button
                *ngIf="isFinalStep"
                type="button"
                class="btn btn-link btn-sm"
                (click)="onEditAnswers()"
              >
                Edit answers
              </button>

              <button
                type="button"
                class="btn btn-link text-danger btn-sm"
                (click)="confirmStartOver()"
              >
                Start over
              </button>
            </div>
          </div>
        </div>

        <div
          class="mt-3 mt-lg-4"
          *ngIf="form && sections.length; else wizardLoading"
        >
          <div
            class="mt-2 mb-3 d-lg-none"
            *ngIf="!previewMode && sections.length"
          >
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="small text-muted">
                Step {{ currentSectionIndex + 1 }} of {{ sections.length }}
              </span>
              <span class="small fw-semibold text-truncate ms-2">
                {{
                  sections[currentSectionIndex]?.sidebarLabel ||
                    sections[currentSectionIndex]?.title
                }}
              </span>
            </div>

            <div class="progress" style="height: 4px">
              <div
                class="progress-bar bg-primary"
                role="progressbar"
                [style.width.%]="
                  ((currentSectionIndex + 1) / sections.length) * 100
                "
                aria-valuemin="0"
                aria-valuemax="100"
                [attr.aria-valuenow]="
                  ((currentSectionIndex + 1) / sections.length) * 100
                    | number: '1.0-0'
                "
              ></div>
            </div>
          </div>

          <div
            class="d-flex gap-4 align-items-stretch"
            [class.wizard-layout--full]="isFinalStep"
          >
            <nav
              class="wizard-sidebar border-end d-none d-lg-block"
              *ngIf="!isFinalStep"
              aria-label="Wizard steps"
            >
              <ol class="list-unstyled mb-0 small">
                <li
                  *ngFor="
                    let section of sections;
                    let i = index;
                    trackBy: trackSection
                  "
                  class="mb-1 pe-3 pe-xl-4"
                >
                  <button
                    type="button"
                    class="w-100 border-0 bg-transparent text-start p-2 rounded-3 d-flex justify-content-between align-items-center"
                    [ngClass]="{
                      'bg-primary bg-opacity-10 fw-semibold':
                        i === currentSectionIndex,
                      'text-muted': i !== currentSectionIndex,
                    }"
                    (click)="goToStep(i)"
                  >
                    <span class="d-flex align-items-center">
                      <span
                        class="d-inline-flex justify-content-center align-items-center rounded-circle me-2"
                        [ngClass]="{
                          'bg-primary text-white': i === currentSectionIndex,
                          'bg-success text-white':
                            i < currentSectionIndex && isSectionComplete(i),
                          'bg-light text-secondary':
                            i > currentSectionIndex ||
                            (i < currentSectionIndex && !isSectionComplete(i)),
                        }"
                        [style.color]="
                          i === currentSectionIndex ? '#fff' : null
                        "
                        style="width: 22px; height: 22px; font-size: 0.75rem"
                      >
                        {{ i + 1 }}
                      </span>

                      <span class="d-flex flex-column">
                        <span
                          class="text-truncate sidebar-label mb-0"
                          style="max-width: 9rem"
                          [class.text-primary]="i === currentSectionIndex"
                        >
                          {{ section.sidebarLabel || section.title }}
                        </span>
                        <small
                          *ngIf="section.subtitle"
                          class="sidebar-subtitle text-muted"
                          style="max-width: 9rem"
                        >
                          {{ section.subtitle }}
                        </small>
                      </span>
                    </span>

                    <span
                      *ngIf="hasCompletedSection(i)"
                      class="text-success d-inline-flex align-items-center gap-1 small py-2"
                    >
                      <i class="fa-solid fa-check"></i>
                    </span>
                  </button>
                </li>
              </ol>
            </nav>

            <div class="wizard-content w-100">
              <div class="wizard-step-wrapper">
                <ng-container *ngIf="!previewMode; else previewPanel">
                  <bylaws-wizard-step
                    [section]="sections[currentSectionIndex]"
                    [form]="form"
                    [draft]="currentDraft"
                    [stepNumber]="currentSectionIndex + 1"
                    [totalSteps]="sections.length"
                    [showErrors]="
                      showErrorsForStepIndex === currentSectionIndex
                    "
                  ></bylaws-wizard-step>
                </ng-container>
              </div>

              <div
                class="step-actions d-flex flex-wrap justify-content-between align-items-center mt-4 pt-3"
              >
                <button
                  type="button"
                  class="btn btn-link text-muted"
                  (click)="prevStep()"
                  [disabled]="
                    !sections.length ||
                    (currentSectionIndex === 0 && !previewMode)
                  "
                >
                  Back
                </button>

                <button
                  type="button"
                  class="btn btn-primary btn-blue text-white"
                  (click)="nextStep()"
                  [disabled]="!sections.length"
                >
                  {{ forwardLabel }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <ng-template #wizardLoading>
          <div class="py-5 text-center text-muted">Loading wizard…</div>
        </ng-template>

        <ng-template #previewPanel>
          <div class="wizard-step">
            <div class="step-content">
              <h2 class="step-title">Your bylaws are ready 🎉</h2>

              <section class="mb-5">
                <div
                  class="card border-start border-4 border-primary bg-primary bg-opacity-10"
                >
                  <div class="card-body">
                    <h2 class="h5 mb-2">Get your bylaws by email</h2>
                    <p class="text-muted mb-3">
                      We’ll send a copy you can forward to your board and keep
                      for your records.
                    </p>

                    <div class="mb-3">
                      <label for="bylawsEmail" class="form-label">
                        Email address
                      </label>
                      <input
                        id="bylawsEmail"
                        name="bylawsEmail"
                        type="email"
                        class="form-control"
                        [(ngModel)]="email"
                        placeholder="you@example.org"
                      />
                    </div>

                    <div class="form-check mb-3">
                      <input
                        id="bylawsTipsOptIn"
                        name="bylawsTipsOptIn"
                        type="checkbox"
                        class="form-check-input"
                        [(ngModel)]="optInToTips"
                      />
                      <label class="form-check-label" for="bylawsTipsOptIn">
                        It’s okay to send me occasional tips and tools for
                        parent–teacher groups.
                      </label>
                    </div>

                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="onEmailBylaws()"
                      [disabled]="isEmailSending || !email?.trim()"
                    >
                      <span *ngIf="!isEmailSending">Email me my bylaws</span>
                      <span *ngIf="isEmailSending">Sending…</span>
                    </button>

                    <p class="mt-3 mb-0 text-muted">
                      or
                      <button
                        type="button"
                        class="btn btn-link p-0 align-baseline"
                        (click)="onDownloadDocx()"
                      >
                        Download as Word Doc (.docx)
                      </button>
                    </p>

                    <div
                      *ngIf="emailSent"
                      class="alert alert-success mt-3 mb-0"
                      role="status"
                    >
                      We’ve emailed your bylaws to
                      <strong>{{ email }}</strong>
                      . Check your inbox and share it with your board.
                    </div>

                    <div
                      *ngIf="emailError"
                      class="alert alert-danger mt-3 mb-0"
                      role="alert"
                    >
                      {{ emailError }}
                    </div>
                  </div>
                </div>
              </section>

              <hr class="bylaws-section-divider my-4" />

              <section class="bylaws-preview card">
                <div class="card-body">
                  <div class="bylaws-preview-content">
                    <app-bylaws-preview></app-bylaws-preview>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </ng-template>

        <div
          class="mt-3 d-flex flex-wrap justify-content-between align-items-center text-muted small"
        >
          <span *ngIf="statusMessage" class="fw-semibold text-primary">
            {{ statusMessage }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
